import styled from "@emotion/styled/macro";
import device from "./device";

const AddButtonWrapper = styled.div`
  margin-top: 24px;

  p {
    font-size: 16px;
    margin: 0;
    padding-bottom: 16px;
    font-weight: 400;
    color: #535862;
  }

  .space-between {
    display: flex;
    gap: 12px;
    width: 100%;

    button {
      flex: 1;
    }
  }

  @media ${device.maxLaptop} {
    margin-bottom: 24px;
  }
`;

export default AddButtonWrapper;